import Modal from "react-modal/lib/components/Modal";
import { IndexHooks } from "./hook";
import closeImg from "../../../../assets/close.png";
import "./style.css";
import "../../../../style/form-register.css";
import { BtnSubmit } from "../../../button/button-submit/button-submit";
import { BtnBack } from "../../../button/button-back";
import libForm from "../../../../util/libForm";
import styled from "styled-components";
import Loading from "../../../loading";
import HeaderRegister from "../../../header/register";
import TextInput from "../../../inputs/text";
import MaskInput from "../../../inputs/mask";
import SelectInput from "../../../inputs/select";
import { BtnCustom } from "../../../button/button";

export const ModalRegisterSupplier = () => {
	const {
		//hook form
		errors,
		isSubmitting,
		register,
		setValue,
		control,
		handleSubmit,
		handleOnSubmit,

		//Data
		citiesData,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		//context
		isOpenModalRegisterSupplier,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		handleCloseModal,
	} = IndexHooks();

	return (
		<Modal
			isOpen={isOpenModalRegisterSupplier}
			onRequestClose={handleCloseModal}
			overlayClassName="modal-overlay-register"
			className="modal-content-form modal-resize"
			shouldCloseOnOverlayClick={false}
		>
			<div className="container-forms">
				<HeaderRegister
					title={"Fornecedor"}
					subTitle={"Cadastro de Fornecedores"}
					handleCloseModal={handleCloseModal}
				/>

				{loading ? (
					<div className="flex h-full">
						<Loading mensagem="Carregando..." />
					</div>
				) : (
					<form className="form" action="" onSubmit={handleSubmit(handleOnSubmit)}>
						<main>
							<input id="id_funcionario" {...register("id_funcionario")} type="hidden" />
							<input id="id_fornecedor" {...register("id_fornecedor")} type="hidden" />
							<input id="data" {...register("data")} type="hidden" />

							<div className="row">
								<TextInput
									label="Nome Fantasia"
									id="fantasia"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									autoFocus={true}
									className="col-12 col-sm-8 col-lg-8"
								/>

								<TextInput
									label="Razão Social"
									id="nome"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-8 col-lg-8"
								/>

								<div className="check-box col-6 col-sm-6 col-lg-2 truncate gap-1">
									<input
										id="pessoafisica"
										type="checkbox"
										{...register("pessoafisica")}
										onKeyDown={(e) => libForm.EnterTab(e)}
									/>
									<label className="" htmlFor="pessoafisica">
										Pessoa Física
									</label>
								</div>

								<div className={`check-box col-6 col-sm-6 col-lg-2 justify-center`}>
									<div className="check-input">
										<input
											className={`${errors.ativo ? "error" : ""}`}
											id="ativo"
											type="checkbox"
											{...register("ativo")}
											onKeyDown={(e) => libForm.EnterTab(e)}
										/>
										<label htmlFor="ativo">Ativo</label>
									</div>
								</div>

								{/* <div className={`check-box col-6 col-sm-2 col-lg-2`}>
									<div className="check-input">
										<input //
											className={`${errors.ativo ? "error" : ""}`}
											id="ativo"
											type="checkbox"
											{...register("ativo")}
											onKeyDown={(e) => libForm.EnterTab(e)}
											autoComplete="off"
										/>
										<label htmlFor="ativo">Ativo</label>
									</div>
								</div>

								<div className="check-box col-6 col-sm-2 col-lg-2">
									<div className="check-input col-6 col-sm-2 col-lg-2">
										<input //
											id="pessoafisica"
											type="checkbox"
											{...register("pessoafisica")}
											onKeyDown={(e) => libForm.EnterTab(e)}
											autoComplete="off"
										/>
										<label className="form-check-label" htmlFor="pessoafisica">
											Pessoa Física
										</label>
									</div>
								</div> */}

								<MaskInput
									label="Cep"
									name="cep"
									control={control}
									errors={errors}
									format="#####-###"
									className="col-4 col-sm-4 col-lg-2"
									onKeyDown={libForm.EnterTab}
								/>

								<div className="col-8 d-flex align-items-center">
									<BtnCustom
										className="btn btn-sm btn-outline-primary btn-cep"
										onClick={(e) => handleFetchAddress()}
										onKeyDown={(e) => libForm.EnterTab(e)}
										text={cepIsSubmitting ? "Buscando..." : "Buscar endereço por CEP"}
									/>
								</div>

								<TextInput
									label="Endereço"
									id="rua"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-8 col-lg-5"
								/>
								<TextInput
									label="Número"
									id="numero"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-4 col-sm-4 col-lg-2"
								/>
								<TextInput
									label="Complemento"
									id="complemento"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-8 col-sm-6 col-lg-2"
								/>
								<TextInput
									label="Bairro"
									id="bairro"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-6 col-lg-3"
								/>
								<SelectInput
									label="Estado"
									id="uf"
									labelSelect="nome"
									control={control}
									errors={errors}
									data={brazilStates}
									setValue={setValue}
									onKeyDown={libForm.EnterTab}
									handleSelect={handleSelectedState}
									loading={loadingCities}
									className="col-12 col-sm-6 col-lg-4"
								/>
								<SelectInput
									label="Cidade"
									id="id_cidade"
									labelSelect="nome"
									control={control}
									errors={errors}
									data={citiesData}
									setValue={setValue}
									onKeyDown={libForm.EnterTab}
									loading={loadingCities}
									className="col-12 col-sm-6 col-lg-4"
								/>

								<div className="col-6 col-sm-3 col-lg-2 input-box">
									<label htmlFor="telefone_1">Celular</label>
									<input //
										className={`${errors.telefone_1 ? "error" : ""}`}
										id="telefone_1"
										{...register("telefone_1")}
										type="text"
										placeholder="Celular"
										onKeyDown={(e) => libForm.EnterTab(e)}
										maxLength={14}
										autoComplete="off"
									/>
									{errors.telefone_1 && <p className="errors">{errors.telefone_1.message}</p>}
								</div>

								<div className="col-6 col-sm-3 col-lg-2 input-box">
									<label htmlFor="telefone_2">Telefone</label>
									<input //
										className={`${errors.telefone_2 ? "error" : ""}`}
										id="telefone_2"
										{...register("telefone_2")}
										type="text"
										placeholder="Telefone"
										onKeyDown={(e) => libForm.EnterTab(e)}
										maxLength={14}
										autoComplete="off"
									/>
									{errors.telefone_2 && <p className="errors">{errors.telefone_2.message}</p>}
								</div>

								<div className="col-6 col-sm-6 col-lg-2 input-box">
									<label htmlFor="cpf">CPF/Cnpj</label>
									<input //
										className={`${errors.cpf ? "error" : ""}`}
										id="cpf"
										{...register("cpf")}
										type="text"
										placeholder="Cpf"
										onKeyDown={(e) => libForm.EnterTab(e)}
										autoComplete="off"
									/>
									{errors.cpf && <p className="errors">{errors.cpf.message}</p>}
								</div>

								<div className="col-6 col-sm-6 col-lg-2 input-box">
									<label htmlFor="rg">RG</label>
									<input //
										className={`${errors.rg ? "error" : ""}`}
										id="state"
										{...register("rg")}
										type="text"
										placeholder="Rg"
										onKeyDown={(e) => libForm.EnterTab(e)}
										autoComplete="off"
									/>
									{errors.rg && <p className="errors">{errors.rg.message}</p>}
								</div>

								<TextInput
									label="E-mail"
									id="email"
									placeholder="E-mail"
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-12 col-lg-4"
								/>
								<TextInput
									label="Observações"
									id="obs"
									placeholder="Obs."
									register={register}
									errors={errors}
									className="col-12 col-sm-12 col-lg-6"
								/>
							</div>
						</main>
						<footer>
							<BtnBack onClick={handleCloseModal} isSubmitting={isSubmitting} />

							<BtnSubmit isSubmitting={isSubmitting} />
						</footer>
					</form>
				)}
			</div>
		</Modal>
	);
};
